module.exports = {
  taluka: {
    466: [
      { id: 4201, name: "Akole" },
      { id: 4202, name: "Sangamner" },
      { id: 4203, name: "Kopargaon" },
      { id: 4204, name: "Rahta" },
      { id: 4205, name: "Shrirampur" },
      { id: 4206, name: "Nevasa" },
      { id: 4207, name: "Shevgaon" },
      { id: 4208, name: "Pathardi" },
      { id: 4209, name: "Nagar" },
      { id: 4210, name: "Rahuri" },
      { id: 4211, name: "Parner" },
      { id: 4212, name: "Shrigonda" },
      { id: 4213, name: "Karjat" },
      { id: 4214, name: "Jamkhed" }
    ],
    467: [
      { id: 3989, name: "Akot" },
      { id: 3990, name: "Balapur" },
      { id: 3991, name: "Akola" },
      { id: 3992, name: "Murtijapur" },
      { id: 3993, name: "Patur" },
      { id: 3994, name: "Barshitakli" }
    ],
    468: [
      { id: 4001, name: "Dharni" },
      { id: 4002, name: "Chikhaldara" },
      { id: 4003, name: "Anjangaon Surji" },
      { id: 4004, name: "Achalpur" },
      { id: 4005, name: "Chandurbazar" },
      { id: 4006, name: "Morshi" },
      { id: 4007, name: "Warud" },
      { id: 4008, name: "Tiosa" },
      { id: 4009, name: "Amravati" },
      { id: 4010, name: "Bhatkuli" },
      { id: 4011, name: "Daryapur" },
      { id: 4012, name: "Nandgaon-Khandeshwar" },
      { id: 4013, name: "Chandur Railway" },
      { id: 4014, name: "Dhamangaon Railway" }
    ],
    469: [
      { id: 4133, name: "Kannad" },
      { id: 4134, name: "Soegaon" },
      { id: 4135, name: "Sillod" },
      { id: 4136, name: "Phulambri" },
      { id: 4137, name: "Chhatrapati Sambhajinagar" },
      { id: 4138, name: "Khuldabad" },
      { id: 4139, name: "Vaijapur" },
      { id: 4140, name: "Gangapur" },
      { id: 4141, name: "Paithan" }
    ],
    470: [
      { id: 4215, name: "Ashti" },
      { id: 4216, name: "Patoda" },
      { id: 4217, name: "Shirur (Kasar)" },
      { id: 4218, name: "Georai" },
      { id: 4219, name: "Majalgaon" },
      { id: 4220, name: "Wadwani" },
      { id: 4221, name: "Beed" },
      { id: 4222, name: "Kaij" },
      { id: 4223, name: "Dharur" },
      { id: 4224, name: "Parli" },
      { id: 4225, name: "Ambejogai" }
    ],
    471: [
      { id: 4037, name: "Tumsar" },
      { id: 4038, name: "Mohadi" },
      { id: 4039, name: "Bhandara" },
      { id: 4040, name: "Sakoli" },
      { id: 4041, name: "Lakhani" },
      { id: 4042, name: "Pauni" },
      { id: 4043, name: "Lakhandur" },
    ],
    472: [
      { id: 3975, name: "Jalgaon (Jamod)" },
      { id: 3976, name: "Sangrampur" },
      { id: 3977, name: "Shegaon" },
      { id: 3978, name: "Nandura" },
      { id: 3979, name: "Malkapur" },
      { id: 3980, name: "Motala" },
      { id: 3981, name: "Khamgaon" },
      { id: 3982, name: "Mehkar" },
      { id: 3983, name: "Chikhli" },
      { id: 3984, name: "Buldana" },
      { id: 3985, name: "Deolgaon Raja" },
      { id: 3986, name: "Sindkhed Raja" },
      { id: 3987, name: "Lonar" },
    ],
    473: [
      { id: 4064, name: "Warora" },
      { id: 4065, name: "Chimur" },
      { id: 4066, name: "Nagbhid" },
      { id: 4067, name: "Brahmapuri" },
      { id: 4068, name: "Sawali" },
      { id: 4069, name: "Sindewahi" },
      { id: 4070, name: "Bhadravati" },
      { id: 4071, name: "Chandrapur" },
      { id: 4072, name: "Mul" },
      { id: 4073, name: "Pombhurna" },
      { id: 4074, name: "Ballarpur" },
      { id: 4075, name: "Korpana" },
      { id: 4076, name: "Jiwati" },
      { id: 4077, name: "Rajura" },
      { id: 4078, name: "Gondpipri" },
    ],
    474: [
      { id: 3956, name: "Shirpur" },
      { id: 3957, name: "Sindkhede" },
      { id: 3958, name: "Sakri" },
      { id: 3959, name: "Dhule" },
    ],
    475: [
      { id: 4052, name: "Desaiganj (Vadasa)" },
      { id: 4053, name: "Armori" },
      { id: 4054, name: "Kurkheda" },
      { id: 4055, name: "Korchi" },
      { id: 4056, name: "Dhanora" },
      { id: 4057, name: "Gadchiroli" },
      { id: 4058, name: "Chamorshi" },
      { id: 4059, name: "Mulchera" },
      { id: 4060, name: "Etapalli" },
      { id: 4061, name: "Bhamragad" },
      { id: 4062, name: "Aheri" },
      { id: 4063, name: "Sironcha" },
    ],
    476: [
      { id: 4044, name: "Tirora" },
      { id: 4045, name: "Goregaon" },
      { id: 4046, name: "Gondiya" },
      { id: 4047, name: "Amgaon" },
      { id: 4048, name: "Salekasa" },
      { id: 4049, name: "Sadak-Arjuni" },
      { id: 4050, name: "Arjuni Morgaon" },
      { id: 4051, name: "Deori" }
    ],
    477: [
      { id: 4111, name: "Sengaon" },
      { id: 4112, name: "Hingoli" },
      { id: 4113, name: "Aundha (Nagnath)" },
      { id: 4114, name: "Kalamnuri" },
      { id: 4115, name: "Vasmath" }
    ],
    478: [
      { id: 3960, name: "Chopda" },
      { id: 3961, name: "Yawal" },
      { id: 3962, name: "Raver" },
      { id: 3963, name: "Muktainagar (Edlabad)" },
      { id: 3964, name: "Bodvad" },
      { id: 3965, name: "Bhusawal" },
      { id: 3966, name: "Jalgaon" },
      { id: 3967, name: "Erandol" },
      { id: 3968, name: "Dharangaon" },
      { id: 3969, name: "Amalner" },
      { id: 3970, name: "Parola" },
      { id: 3971, name: "Bhadgaon" },
      { id: 3972, name: "Chalisgaon" },
      { id: 3973, name: "Pachora" },
      { id: 3974, name: "Jamner" }
    ],
    479: [
      { id: 4125, name: "Bhokardan" },
      { id: 4126, name: "Jafrabad" },
      { id: 4127, name: "Jalna" },
      { id: 4128, name: "Badnapur" },
      { id: 4129, name: "Ambad" },
      { id: 4130, name: "Ghansawangi" },
      { id: 4131, name: "Partur" },
      { id: 4132, name: "Mantha" }
    ],
    480: [
      { id: 4283, name: "Shahuwadi" },
      { id: 4284, name: "Panhala" },
      { id: 4285, name: "Hatkanangle" },
      { id: 4286, name: "Shirol" },
      { id: 4287, name: "Karvir" },
      { id: 4288, name: "Gaganbawada" },
      { id: 4289, name: "Radhanagari" },
      { id: 4290, name: "Kagal" },
      { id: 4291, name: "Bhudargad" },
      { id: 4292, name: "Ajra" },
      { id: 4293, name: "Gadhinglaj" },
      { id: 4294, name: "Chandgad" }
    ],
    481: [
      { id: 4226, name: "Latur" },
      { id: 4227, name: "Renapur" },
      { id: 4228, name: "Ahmadpur" },
      { id: 4229, name: "Jalkot" },
      { id: 4230, name: "Chakur" },
      { id: 4231, name: "Shirur Anantpal" },
      { id: 4232, name: "Ausa" },
      { id: 4233, name: "Nilanga" },
      { id: 4234, name: "Deoni" },
      { id: 4235, name: "Udgir" }
    ],
    483: [
        { id: 7179, name: "Andheri" },
        { id: 7180, name: "Kurla" },
        { id: 7181, name: "Borivali" }
    ],
    484: [
      { id: 4023, name: "Narkhed" },
      { id: 4024, name: "Katol" },
      { id: 4025, name: "Kalameshwar" },
      { id: 4026, name: "Savner" },
      { id: 4027, name: "Parseoni" },
      { id: 4028, name: "Ramtek" },
      { id: 4029, name: "Mauda" },
      { id: 4030, name: "Kamptee" },
      { id: 4031, name: "Nagpur (Rural)" },
      { id: 4032, name: "Nagpur (Urban)" },
      { id: 4033, name: "Hingna" },
      { id: 4034, name: "Umred" },
      { id: 4035, name: "Kuhi" },
      { id: 4036, name: "Bhiwapur" }
    ],
    485: [
      { id: 4095, name: "Mahur" },
      { id: 4096, name: "Kinwat" },
      { id: 4097, name: "Himayatnagar" },
      { id: 4098, name: "Hadgaon" },
      { id: 4099, name: "Ardhapur" },
      { id: 4100, name: "Nanded" },
      { id: 4101, name: "Mudkhed" },
      { id: 4102, name: "Bhokar" },
      { id: 4103, name: "Umri" },
      { id: 4104, name: "Dharmabad" },
      { id: 4105, name: "Biloli" },
      { id: 4106, name: "Naigaon (Khairgaon)" },
      { id: 4107, name: "Loha" },
      { id: 4108, name: "Kandhar" },
      { id: 4109, name: "Mukhed" },
      { id: 4110, name: "Deglur" }
    ],
    486:[
      { id: 3950, name: "Akkalkuwa" },
      { id: 3951, name: "Akrani" },
      { id: 3952, name: "Talode" },
      { id: 3953, name: "Shahade" },
      { id: 3954, name: "Nandurbar" },
      { id: 3955, name: "Nawapur" }
    ],
    487:[
      { id: 4142, name: "Surgana" },
      { id: 4143, name: "Kalwan" },
      { id: 4144, name: "Deola" },
      { id: 4145, name: "Baglan" },
      { id: 4146, name: "Malegaon" },
      { id: 4147, name: "Nandgaon" },
      { id: 4148, name: "Chandvad" },
      { id: 4149, name: "Dindori" },
      { id: 4150, name: "Peth" },
      { id: 4151, name: "Trimbakeshwar" },
      { id: 4152, name: "Nashik" },
      { id: 4153, name: "Igatpuri" },
      { id: 4154, name: "Sinnar" },
      { id: 4155, name: "Niphad" },
      { id: 4156, name: "Yevla" }
    ],
    488: [
      { id: 4236, name: "Paranda" },
      { id: 4237, name: "Bhum" },
      { id: 4238, name: "Washi" },
      { id: 4239, name: "Kalamb" },
      { id: 4240, name: "Dharashiv" },
      { id: 4241, name: "Tuljapur" },
      { id: 4242, name: "Lohara" },
      { id: 4243, name: "Omarga" }
    ],
    489: [
      { id: 4116, name: "Selu" },
      { id: 4117, name: "Jintur" },
      { id: 4118, name: "Parbhani" },
      { id: 4119, name: "Manwath" },
      { id: 4120, name: "Pathri" },
      { id: 4121, name: "Sonpeth" },
      { id: 4122, name: "Gangakhed" },
      { id: 4123, name: "Palam" },
      { id: 4124, name: "Purna" }
    ],
    490: [
      { id: 4187, name: "Junnar" },
      { id: 4188, name: "Ambegaon" },
      { id: 4189, name: "Shirur" },
      { id: 4190, name: "Khed" },
      { id: 4191, name: "Mawal" },
      { id: 4192, name: "Mulshi" },
      { id: 4193, name: "Haveli" },
      { id: 4194, name: "Pune City" },
      { id: 4195, name: "Daund" },
      { id: 4196, name: "Purandhar" },
      { id: 4197, name: "Velhe" },
      { id: 4198, name: "Bhor" },
      { id: 4199, name: "Baramati" },
      { id: 4200, name: "Indapur" }
    ],
    491: [
      { id: 4172, name: "Uran" },
      { id: 4173, name: "Panvel" },
      { id: 4174, name: "Karjat" },
      { id: 4175, name: "Khalapur" },
      { id: 4176, name: "Pen" },
      { id: 4177, name: "Alibag" },
      { id: 4178, name: "Murud" },
      { id: 4179, name: "Roha" },
      { id: 4180, name: "Sudhagad" },
      { id: 4181, name: "Mangaon" },
      { id: 4182, name: "Tala" },
      { id: 4183, name: "Shrivardhan" },
      { id: 4184, name: "Mhasla" },
      { id: 4185, name: "Mahad" },
      { id: 4186, name: "Poladpur" }
    ],
    492: [
      { id: 4266, name: "Mandangad" },
      { id: 4267, name: "Dapoli" },
      { id: 4268, name: "Khed" },
      { id: 4269, name: "Chiplun" },
      { id: 4270, name: "Guhagar" },
      { id: 4271, name: "Ratnagiri" },
      { id: 4272, name: "Sangameshwar" },
      { id: 4273, name: "Lanja" },
      { id: 4274, name: "Rajapur" }
    ],
    493: [
      { id: 4295, name: "Shirala" },
      { id: 4296, name: "Walwa" },
      { id: 4297, name: "Palus" },
      { id: 4298, name: "Kadegaon" },
      { id: 4299, name: "Khanapur" },
      { id: 4300, name: "Atpadi" },
      { id: 4301, name: "Tasgaon" },
      { id: 4302, name: "Miraj" },
      { id: 4303, name: "Kavathemahankal" },
      { id: 4304, name: "Jat" }
    ],
    494: [
      { id: 4255, name: "Mahabaleshwar" },
      { id: 4256, name: "Wai" },
      { id: 4257, name: "Khandala" },
      { id: 4258, name: "Phaltan" },
      { id: 4259, name: "Man" },
      { id: 4260, name: "Khatav" },
      { id: 4261, name: "Koregaon" },
      { id: 4262, name: "Satara" },
      { id: 4263, name: "Jaoli" },
      { id: 4264, name: "Patan" },
      { id: 4265, name: "Karad" }
    ],
    495: [
      { id: 4275, name: "Devgad" },
      { id: 4276, name: "Vaibhavvadi" },
      { id: 4277, name: "Kankavli" },
      { id: 4278, name: "Malwan" },
      { id: 4279, name: "Vengurla" },
      { id: 4280, name: "Kudal" },
      { id: 4281, name: "Sawantwadi" },
      { id: 4282, name: "Dodamarg" }
    ],
    496: [
      { id: 4244, name: "Karmala" },
      { id: 4245, name: "Madha" },
      { id: 4246, name: "Barshi" },
      { id: 4247, name: "Solapur North" },
      { id: 4248, name: "Mohol" },
      { id: 4249, name: "Pandharpur" },
      { id: 4250, name: "Malshiras" },
      { id: 4251, name: "Sangole" },
      { id: 4252, name: "Mangalvedhe" },
      { id: 4253, name: "Solapur South" },
      { id: 4254, name: "Akkalkot" }
    ],
    497: [
      { id: 4165, name: "Thane" },
      { id: 4166, name: "Bhiwandi" },
      { id: 4167, name: "Shahapur" },
      { id: 4168, name: "Kalyan" },
      { id: 4169, name: "Ulhasnagar" },
      { id: 4170, name: "Ambarnath" },
      { id: 4171, name: "Murbad" }
    ],
    498: [
      { id: 4015, name: "Ashti" },
      { id: 4016, name: "Karanja" },
      { id: 4017, name: "Arvi" },
      { id: 4018, name: "Seloo" },
      { id: 4019, name: "Wardha" },
      { id: 4020, name: "Deoli" },
      { id: 4021, name: "Hinganghat" },
      { id: 4022, name: "Samudrapur" }
    ],
    499: [
      { id: 3995, name: "Malegaon" },
      { id: 3996, name: "Mangrulpir" },
      { id: 3997, name: "Karanja" },
      { id: 3998, name: "Manora" },
      { id: 3999, name: "Washim" },
      { id: 4000, name: "Risod" }
    ],
    500: [
      { id: 4001, name: "Darwha" },
      { id: 4002, name: "Digras" },
      { id: 4003, name: "Ner" },
      { id: 4004, name: "Yavatmal" },
      { id: 4005, name: "Kalamb" },
      { id: 4006, name: "Babulgaon" },
      { id: 4007, name: "Ralegaon" },
      { id: 4008, name: "Ghatanji" },
      { id: 4009, name: "Kelapur" },
      { id: 4010, name: "Wani" },
      { id: 4011, name: "Zari Jamani" },
      { id: 4012, name: "Pandharkawda" },
      { id: 4013, name: "Pusad" },
      { id: 4014, name: "Umarkhed" }
    ],
    665: [
      { id: 4157, name: "Talasari" },
      { id: 4158, name: "Dahanu" },
      { id: 4159, name: "Vikramgad" },
      { id: 4160, name: "Jawhar" },
      { id: 4161, name: "Mokhada" },
      { id: 4162, name: "Wada" },
      { id: 4163, name: "Palghar" },
      { id: 4164, name: "Vasai" },
    ]
  }
};
